import React from "react";
import { cn } from "@/lib/utils";

interface TimelineConnectorProps {
  /** Direction the connector extends from the stem */
  direction: "left" | "right";
  /** Additional CSS classes */
  className?: string;
}

/**
 * TimelineConnector - Atom component
 *
 * A horizontal line connecting a timeline node card to the central stem.
 * Extends either left or right from the stem.
 *
 * @example
 * ```tsx
 * <TimelineConnector direction="left" />
 * <TimelineConnector direction="right" />
 * ```
 */
export const TimelineConnector = React.memo(function TimelineConnector({
  direction,
  className,
}: TimelineConnectorProps) {
  return (
    <div
      className={cn(
        // shrink-0: the node row is a flex row of connector + dot + card, and
        // the card is `w-full`. Without this the row overflows and the browser
        // shrinks every item, so a wide card squeezes the connector to nothing
        // and that document loses its line to the stem.
        "h-0.5 w-8 shrink-0 bg-border",
        direction === "left" && "mr-0",
        direction === "right" && "ml-0",
        className
      )}
      aria-hidden="true"
    />
  );
});
